import { useShallow } from 'zustand/react/shallow';

import FileDropzone from '@/components/ui/file-dropzone';

import { ALLOWED_FILE_TYPES, MAX_FILE_SIZE } from '@/constants';

import { selectFileUploadState } from '@/store/document-upload.selectors';
import { useDocumentUploadStore } from '@/store/document-upload.store';

type FileUploadSectionProps = {
  onFileSelect: (files: File[]) => void;
};

export function FileUploadSection({ onFileSelect }: FileUploadSectionProps) {
  const { uploadedFile, validationErrors } = useDocumentUploadStore(
    useShallow(selectFileUploadState)
  );

  const setValidationErrors = useDocumentUploadStore(state => state.setValidationErrors);

  const accept = ALLOWED_FILE_TYPES.map(type => `.${type}`).join(',');

  return (
    <div className="space-y-2">
      <FileDropzone
        value={uploadedFile}
        accept={accept}
        maxSize={MAX_FILE_SIZE}
        onChange={files => onFileSelect(files ? [files] : [])}
        onError={message => setValidationErrors([{ file: 'general', message }])}
      />

      {validationErrors.length > 0 && (
        <div className="space-y-1">
          {validationErrors.map(error => (
            <p key={error.file} className="text-sm text-destructive">
              {error.file !== 'general' && <span className="font-medium">{error.file}: </span>}
              {error.message}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
